import script from "./HotSales.vue?vue&type=script&setup=true&lang=ts"
export * from "./HotSales.vue?vue&type=script&setup=true&lang=ts"

import "./HotSales.vue?vue&type=style&index=0&id=21762b42&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21762b42"]])

export default __exports__